module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-sn.3d8d70ba.png";